import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

export interface VersionInfo {
  branch: string;
  commit: string;
  ghRunName: string;
  ghRunNumber: string;
  ghRunUrl: string;
  environment: string;
  buildTime: string;
}

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly versionInfo$: Observable<VersionInfo | null>;

  constructor(private http: HttpClient) {
    this.versionInfo$ = this.http.get<VersionInfo>('/version.json').pipe(
      catchError(() => {
        return of(null);
      }),
      shareReplay(1)
    );
  }

  getVersionInfo(): Observable<VersionInfo | null> {
    return this.versionInfo$;
  }

  getGhRunNumber(): Observable<string | null> {
    return this.getVersionInfo().pipe(
      map(info => info?.ghRunNumber || null),
      catchError(() => of(null))
    );
  }
}
